import * as React from 'react';
import { connect } from 'react-redux';
import BoltIcon from '@mui/icons-material/Bolt';
import ViewModuleIcon from '@mui/icons-material/ViewModule';

type Props = {
  moduleSelector: moduleSelectorState,
  panels: any,
  rubberBand: any,
};

class ModulesInfo extends React.Component<Props, {}> {
  render() {
    const output = this.props.moduleSelector.modelData.watts;
    const modules = this.props.panels.panels.length + this.props.rubberBand.panelsShadow.length - this.props.rubberBand.panelsToRemove.length;
    const Kw = parseFloat((modules * output / 1000).toFixed(2))

    return (
      <div className="total-modules-kw">
               
            <div className="value total-modules-quantity " id="mid-bar-value">{modules || 0}</div>
             <div className="label" id="mid-bar-info">Modules,</div>


          
            <div className="value total-kw-quantity" id="mid-bar-value">{Kw || 0}</div>
              <div className="label" id="mid-bar-info"> kW</div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    moduleSelector: state.moduleSelector,
    panels: state.panels,
    rubberBand: state.rubberBand,
  };
}

export default connect(mapStateToProps)(ModulesInfo);
